<template>
    <div style="height: 100%;display: flex;width: 100%;padding-right: 20px">
    <div class="second-display-container">
            <div v-for="(office,index) in data" :key="index" class="show-box">
                <div class="box-first-value">
                    <div :id="'identifier-'+office.public_identifier.replace(' ','')" class="value">{{ office.public_identifier.replace(' ','') }}</div>
                </div>
                <div style="display: flex;width: 200px !important">
                    <div style="margin: auto">
                        <img src="../assets/icons/biat-dark-arrow.svg" alt=""/>
                    </div>
                </div>
                <div class="box-second-value">
                    <div :id="'counter-'+office.counter_name.replace(' ','')" class="value">{{ office.counter_name }}</div>
                </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'LbrxDisplayBiatThirdTheme',
    props: {
        data: {type: Array, required: true}
    },
    data() {
        return {
            offices: this.data,
        }
    }, methods: {
        isBigWidthMethod() {
            for(let i=0;i<this.data.length;i++) {
                if(this.data[i].public_identifier.length > 3) {
                    return true;
                }
            }
            return false;
        },
    },

    computed: {
        isBigWidth() {
            for(let i=0;i<this.data.length;i++) {
                if(this.data[i].public_identifier.length > 3) {
                    return true;
                }
            }
            return false;
        },

        getBigWidth() {
            let bigWidth = 3;
            for(let i=0;i<this.data.length;i++) {
                if(this.data[i].public_identifier.length >bigWidth) {
                    bigWidth = this.data[i].public_identifier.length;
                }
            }
            return 100+(345/bigWidth)+'%'
        },
        lineHeight() {
            if(this.data.length >= 3) {
                return 60 / this.data.length + "vh";
            }
            else if(this.data.length === 2) {
                if(this.isBigWidthMethod()) {
                    return 58 / this.data.length + "vh";
                }
                return 48 / this.data.length + "vh";
            }
            else {
                if(this.isBigWidthMethod()) {
                    return 28 / this.data.length + "vh";
                }
                return 26 / this.data.length + "vh";
            }

        },
        valueSize() {
            if(this.data.length === 1) {
                if(this.isBigWidthMethod())
                    return 3.6+'vw';
                return 5.8+"vw";
            }
            if(this.data.length === 2) {
                if (this.isBigWidthMethod())
                    return 3.5 + 'vw';
                return 6 + 'vw';
            }
            if(this.isBigWidthMethod())
                return 3.2+'vw';
            return 17/this.data.length+"vw";
        },
    }
}
</script>

<style scoped>
.show-box {
    margin-bottom: 2vmin;
    height: v-bind(lineHeight);
    display: flex;
    width: 100%;
}
.box-second-value {
    height: 100%;
    padding-left: 8%;
    padding-right: 8%;
    width: auto;
    min-width: 250px;
    display: flex;
    justify-content: center;
    font-family: 'Digital Numbers', serif;
    font-size: v-bind(valueSize);
    color: #F39800;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background: #FFFFFF;
    border-radius: 3vmin;
}

.box-second-value .value {
    margin: auto;
}

.box-first-value {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background: #FFFFFF;
    border-radius: 3vmin;
    z-index: 99;
    height: v-bind(lineHeight);
    display: flex;
    justify-content: center;
    font-family: 'Digital Numbers', serif;
    font-size: v-bind(valueSize);
    color: #244578;
    width: 100% !important;
    min-width: 190px;
}
.box-first-value .value {
    margin: auto !important;
}
.second-display-container {
    height: fit-content;
    margin-top: auto;
    margin-bottom: auto;
    width: 100% !important;
    float: right;
}

.title-box {
    display: flex;
    width: 78%;
    margin-left: 6vmin;
}
</style>